export const networkDeviceContentConstants = {
    NETWORK_DEVICE_CONTENT_BY_ID_REQUEST: "NETWORK_DEVICE_CONTENT_BY_ID_REQUEST",
    NETWORK_DEVICE_CONTENT_BY_ID_SUCCESS: "NETWORK_DEVICE_CONTENT_BY_ID_SUCCESS",
    NETWORK_DEVICE_CONTENT_BY_ID_FAILURE: "NETWORK_DEVICE_CONTENT_BY_ID_FAILURE",
    NETWORK_DEVICE_CONTENT_CLEAR: "NETWORK_DEVICE_CONTENT_CLEAR",

    NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_REQUEST: "NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_REQUEST",
    NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_SUCCESS: "NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_SUCCESS",
    NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_FAILURE: "NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_FAILURE",

    NETWORK_DEVICE_CONTENT_DEFAULT_APP_REQUEST: "NETWORK_DEVICE_CONTENT_DEFAULT_APP_REQUEST",
    NETWORK_DEVICE_CONTENT_DEFAULT_APP_SUCCESS: "NETWORK_DEVICE_CONTENT_DEFAULT_APP_SUCCESS",
    NETWORK_DEVICE_CONTENT_DEFAULT_APP_FAILURE: "NETWORK_DEVICE_CONTENT_DEFAULT_APP_FAILURE",

    LAUNCHER_DROPDOWN_REQUEST: "LAUNCHER_DROPDOWN_REQUEST",
    LAUNCHER_DROPDOWN_SUCCESS: "LAUNCHER_DROPDOWN_SUCCESS",
    LAUNCHER_DROPDOWN_FAILURE: "LAUNCHER_DROPDOWN_FAILURE",
};
